import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isNil } from '@pct-ts/typeguard';

@Pipe({
  name: 'isNil',
})
export class IsNilPipe implements PipeTransform {
  transform(value: unknown): value is null | undefined {
    return isNil(value);
  }
}
